import * as React from 'react';
import BlockedSendersFull from './components/BlockedSendersFull';
import discardBlockedSendersOption from './actions/discardBlockedSendersOption';
import isBlockedSendersOptionDirty from './utils/isBlockedSendersOptionDirty';
import saveBlockedSendersOption from './actions/saveBlockedSendersOption';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

const BlockedSendersOption: Option = {
    key: 'blockedSenders',
    titleStringKey: 'optionTitle_blockedSenders',
    searchTermsStringKey: 'optionSearchTerms_blockedSenders',
    fullOptionFormSettings: {
        render: () => <BlockedSendersFull />,
        isDirty: isBlockedSendersOptionDirty,
        onSave: saveBlockedSendersOption,
        onDiscard: discardBlockedSendersOption,
    },
    allowedOptionKeys: ['BlockSenders'],
    isHidden: () => {
        return isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
    },
};

export default BlockedSendersOption;
